export default __webpack_public_path__ + "static/media/Deli_Wrong.213cd54c.svg";